import { render, staticRenderFns } from "./GRC.vue?vue&type=template&id=18ed7950&"
import script from "./GRC.vue?vue&type=script&lang=js&"
export * from "./GRC.vue?vue&type=script&lang=js&"
import style0 from "./GRC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ed7950')) {
      api.createRecord('18ed7950', component.options)
    } else {
      api.reload('18ed7950', component.options)
    }
    module.hot.accept("./GRC.vue?vue&type=template&id=18ed7950&", function () {
      api.rerender('18ed7950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/GRC.vue"
export default component.exports